<router-outlet><app-spinner></app-spinner></router-outlet>
<ng2-toasty></ng2-toasty>